<template>
  <div class="form-group search-input">
    <fa
      icon="search"
      class="search-input__icon"
      fixed-width
    />
    <input
      type="search"
      class="form-control"
      placeholder="Search"
      :value="value"
      @input="$emit('input', $event.target.value)"
    >
  </div>
</template>

<script>
export default {
  name: 'VSearchInput',
  props: {
    value: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
input[type="search"]::-webkit-search-cancel-button:hover {
    cursor:pointer;
}
</style>
